import { useToast } from "./useToast";
import { useTranslations } from "./useTranslations";

interface UseClipboardResult {
  copyToClipboard: (text: string, customToast?: string) => Promise<void>;
}

export const useClipboard = (): UseClipboardResult => {
  const { toast } = useToast({ variant: "web" });
  const { t } = useTranslations();

  const copyToClipboard = async (text: string, customToast?: string) => {
    try {
      await navigator.clipboard.writeText(text);
      toast(
        customToast ||
          t({
            id: "feedback.copied-to-clipboard",
            defaultMessage: "Copied to clipboard",
          })
      );
    } catch (err) {
      toast(
        t({
          id: "feedback.failed-to-copy-to-clipboard",
          defaultMessage: "Failed to copy to clipboard",
        }),
        {
          variant: "error",
        }
      );
    }
  };

  return { copyToClipboard };
};
